import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  matchPath
} from "react-router-dom";
import { initGA, logPageView } from "./analytics";
//import Projetos from "./components/projetos";
import './App.css'
import SideBar from "./components/appBar";
import Home from "./components/home";
import Equipe from "./components/equipe";
import Associado from "./components/associado";
import Sobre from "./components/sobre";
import Contato from "./components/contato";
import Posts from "./components/posts";
import PostSP from "./components/postSP";
import Transparencia from "./components/transparencia";
import Rascunhos from "./components/rascunhos";
import CookieConsent from "./permissaoCookies";

function AnalyticsTracker() {
  const location = useLocation();
  const consent = localStorage.getItem('cookieConsent');


  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    if (consent === 'true') {
      logPageView(location.pathname + location.search);
    }
  }, [location, consent]);

  return null;
}

const RouterWrapper = () => {
  const location = useLocation();

  // Verifica se a rota atual corresponde a /site/:postUrl
  const isSitePost = matchPath("/site/:postUrl", location.pathname);

  // Oculta o Sidebar apenas nessa rota
  if (isSitePost) {
    return (
      <div className="body no-sidebar">
        <AppRoutes />
      </div>
    );
  } else {
    return (
      <>
        <SideBar />
      <div className="body">
        <AppRoutes />
      </div>
    </>
  );
};
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route>
        <Route path="/" element={<Home />} exact />
        <Route path="/equipe" element={<Equipe />} exact />
        <Route path="/sobre" element={<Sobre />} exact />
        <Route path="/contato" element={<Contato />} exact />
              {/*<Route path="/projetos" element={<Projetos />} exact />
              <Route path="/projetos/:tagParam" element={<Projetos />} exact />*/}
              <Route path="/membro/:idDoUserParam" element={<Associado />} exact />
              <Route path="/posts" element={<Posts categoria="Postagem de Blog" />} exact />
              <Route path="/rascunhos" element={<Rascunhos />} exact />
              <Route path="/posts/:tagParam" element={<Posts categoria="Postagem de Blog" />} exact />
              <Route path="/transparencia/:secao?" element={<Transparencia />} exact />
              <Route path="/post/:postUrl" element={<PostSP />} exact />
              <Route path="/pagina/:postUrl" element={<PostSP />} exact />
              <Route path="/site/:postUrl" element={<PostSP />} exact />
            </Route>
          </Routes>
)};


function App() {
  useEffect(() => {
    document.title = 'Modular ATHIS';
  });
  return (
    <div
      className="App"
    >
      <Router>
        <CookieConsent />
        <AnalyticsTracker />
        <RouterWrapper />
      </Router>
    </div>
  );
}

export default App;
